module.exports = __webpack_public_path__ + "img/dir-img.39348509.jpeg";